import React, { Component } from "react";
import { Button, Table, Form, FormGroup, Card, CardBody, Label } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import Moment from "react-moment";
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as giaoHangAction from './actions'
import * as giaoHangConstant from './constants'
import * as common from '../../lib/common'
import { storedb } from '../client/storedb'
import { currentDate, getMonthFromDate, getYearFromDate } from '../../lib/common';
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const TrangThaiGiao = {
  DangGiao: { value: 1, text: "Đang giao" },
  DaGiao: { value: 20, text: "Đã giao" },
  TamDung: { value: 9, text: "Tạm dừng" },
}
class GiaoHangEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      OrderId: "",
      GhiChu: "",
      TrangThai: 0,
      TenTrangThai: "",
      ThanhToan: 0,
      ShowMore: false,
      listHistory: [],
      NgayGiao: currentDate(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    this.setState({ GhiChu: e.target.value })
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        let tenTrangThai = '';
        if (selectedOption.target.value == 1) {
          tenTrangThai = "Đang giao";
        } else if (selectedOption.target.value == 20) {
          tenTrangThai = "Đã giao";
        } else if (selectedOption.target.value == 9) {
          tenTrangThai = "Tạm dừng";
        }
        this.setState({ TrangThai: selectedOption.target.value, TenTrangThai: tenTrangThai });
        break;
      default:
        break;
    }
  }
  handleThanhToanChange = (data) => {
    const value = data.floatValue;
    this.setState({ ThanhToan: value })
  }
  handleDateChange(name, e, value) {
    this.setState({ NgayGiao: e });
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  handleShowMore = () => {
    this.setState({ ShowMore: !this.state.ShowMore })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { giaoHangDetailRequest } = this.props
    let order_id = this.getParam("o");
    this.setState({ OrderId: order_id })
    var requestData = {
      order_id: order_id || 0
    }
    return giaoHangDetailRequest(requestData);
  }
  featchHistory = () => {
    const { giaoHangHistoryListRequest } = this.props
    var requestData = {
      order_id: this.state.OrderId || 0,
      stores_id: this.state.stores_id,
      page: 1,
      per_page: 20
    }
    return giaoHangHistoryListRequest(requestData);
  }

  UpdategiaoHang = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.OrderId || this.state.OrderId == "") {
      formError.errMsg = 'Không tồn tại thông tin đơn hàng';
    }
    if (this.state.TrangThai == "" || this.state.TrangThai == 0) {
      formError.errMsg = 'Bạn chưa nhập trạng thái';
    }
    if (!this.state.NgayGiao || this.state.NgayGiao == "") {
      formError.errMsg = 'Bạn chưa nhập ngày giao';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let arrOrder = [];
      arrOrder.push({ BanId: this.state.OrderId })
      let requestData = {
        OrderId: arrOrder,
        StoreId: this.state.stores_id,
        GhiChu: this.state.GhiChu,
        TrangThai: this.state.TrangThai,
        TenTrangThai: this.state.TenTrangThai,
        NgayGiao: this.state.NgayGiao,
        ThanhToan: this.state.ThanhToan,
        Month: getMonthFromDate(this.state.NgayGiao),
        Year: getYearFromDate(this.state.NgayGiao),
      }
      this.props.giaoHangUpdateRequest(requestData);
    }
  }
  BackToListgiaoHang = (item, e) => {
    e.preventDefault();
    this.props.history.push('/giaoHang');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.giaoHangEdit.type == giaoHangConstant.GIAOHANG_DETAIL_SUCCESS) {
      let { item } = nextProps.giaoHangEdit;
      if (item.order_id && item.order_id != '') {
        this.setState({
          item,
          TrangThai: item.trang_thai_giao,
          GhiChu: item.GhiChu,
          ThanhToan: item.tong_tien
        }, () => {
          this.featchHistory()
        });
      }
    } else if (nextProps.giaoHangEdit.type == giaoHangConstant.GIAOHANG_UPDATE_SUCCESS) {
      this.props.history.push("/giaohang");
    } else if (nextProps.giaoHangEdit.type == giaoHangConstant.GIAOHANG_HISTORY_LIST_SUCCESS) {
      let { listHistory } = nextProps.giaoHangEdit;
      if (listHistory && listHistory.length > 0) {
        this.setState({ ThanhToan: (this.state.item.tong_tien - common.sum(listHistory, "SoTienThu")) })
      }
    }
  }
  render() {
    const { item, formError } = this.state;
    const {
      handleSubmit,
      giaoHangEdit: {
        isRequesting,
        errors,
        messages,
        listHistory
      },
    } = this.props
    const sumQuantity = () => {
      const items = this.props.giaoHangEdit.item.items || [];
      return common.sum(items, "so_luong").toLocaleString()
    }
    const sumRefun = () => {
      const items = this.props.giaoHangEdit.item.items || [];
      return common.sum(items, "chiet_khau").toLocaleString()
    }
    const sumVat = () => {
      const items = this.props.giaoHangEdit.item.items || [];
      return common.sum(items, "vat").toLocaleString()
    }
    const sumFee = () => {
      const items = this.props.giaoHangEdit.item.items || [];
      return common.sum(items, "thanh_tien").toLocaleString()
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={isRequesting} >
          <div className="col-sm-8 col-md-9 pull-left">
            <Card>
              <CardBody className="p-1 order-view">
                <div className="w-100 text-white bg-green">
                  <h5 className="p-1 pull-left mb-0">THÔNG TIN ĐƠN HÀNG</h5>
                  <span className="pull-right p-1 font-weight-bold cursor-pointer" onClick={this.handleShowMore}>
                    {this.state.ShowMore ? <span><i className="fa fa-lg fa-angle-double-up text-white"></i> Thu gọn</span> : <span><i className="fa fa-lg fa-angle-double-down text-white"></i> Chi tiết</span>}
                  </span>
                  <div className="clearfix"></div>
                </div>
                <div className="w-100 col-sm-12 pl-0 pr-0">
                  <div className="col-sm-6 pull-left p-1 view-row">
                    <div className="col-sm-4 pr-1 pull-left">Khách hàng</div>
                    <div className="col-sm-8 pull-left">
                      <span className="font-weight-bold">{item.ten_khach_hang}</span>
                    </div>
                  </div>
                  <div className="col-sm-6 pull-left p-1 view-row">
                    <div className="col-sm-4 pr-1 pull-left">Điện thoại</div>
                    <div className="col-sm-8 pull-left">
                      <span className="font-weight-bold">{item.dien_thoai}</span>
                    </div>
                  </div>
                  <div className="col-sm-12 pull-left p-1 view-row">
                    <div className="col-sm-2 pr-1 pull-left">Địa chỉ</div>
                    <div className="col-sm-10 pull-left">
                      <span className="font-weight-bold">{item.dia_chi}</span>
                    </div>
                  </div>
                  <div className="div-show-more" style={{ display: this.state.ShowMore ? "block" : "none" }}>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Mã đơn hàng</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{item.ma_don_hang}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Trạng thái</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{common.getOrdetStatusText(item.trang_thai, true)}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Ngày lập</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">
                          {item.ngay_lap && <Moment format="HH:mm DD/MM/YYYY">{`${item.ngay_lap}`}</Moment>}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Ngày giao</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">
                          {item.ngay_giao && <Moment format="HH:mm DD/MM/YYYY">{`${item.ngay_giao}`}</Moment>}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Nhân viên</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{item.ten_nhan_vien}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Xuất hóa đơn</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{item.xuat_hoa_don ? 'Có' : 'Không'}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Nơi xuất</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{item.noi_xuat}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 pull-left p-1 view-row">
                      <div className="col-sm-4 pr-1 pull-left">Ký HĐ</div>
                      <div className="col-sm-8 pull-left">
                        <span className="font-weight-bold">{item.bo_chiet_khau ? 'Có' : "Không"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 pull-left p-1 view-row">
                    <div className="col-sm-2 pr-1 pull-left">Ghi chú</div>
                    <div className="col-sm-10 pull-left">
                      <span className="font-weight-bold">{item.ghi_chu}</span>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="w-100 mb-2 text-white bg-green">
                  <h5 className="p-1">CHI TIẾT ĐƠN HÀNG</h5>
                  <div className="clearfix"></div>
                </div>
                <div className="w-100 mb-2">
                  <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                    <thead className="thead-default">
                      <tr>
                        <th scope="col" className="text-center">#</th>
                        <th scope="col" className="text-left">Tên hàng</th>
                        <th scope="col" className="text-right">Số lượng</th>
                        <th scope="col" className="text-right">Đơn giá</th>
                        <th scope="col" className="text-right">Chiết khấu</th>
                        <th scope="col" className="text-right">VAT</th>
                        <th scope="col" className="text-right">Thành tiền</th>
                        <th scope="col" className="text-left">Ghi chú</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.items && !!item.items.length && (
                        item.items.map((res, idx) => (
                          <tr key={idx + 1}>
                            <td className="text-center">{idx + 1}</td>
                            <td className="text-left">{res.ten_hang}</td>
                            <td className="text-right">{(res.so_luong || 0).toLocaleString()}</td>
                            <td className="text-right">{(res.gia_ban || 0).toLocaleString()}</td>
                            <td className="text-right">{(res.chiet_khau || 0)}</td>
                            <td className="text-right">{(res.vat || 0).toLocaleString()}</td>
                            <td className="text-right font-weight-bold">{(res.thanh_tien || 0).toLocaleString()}</td>
                            <td className="text-left"></td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2">
                          <span className="font-weight-bold">Tổng cộng</span>
                        </td>
                        <td className="text-right"><b>{sumQuantity()}</b></td>
                        <td></td>
                        <td className="text-right"><b>{sumRefun()}</b></td>
                        <td className="text-right"><b>{sumVat()}</b></td>
                        <td className="text-right"><b>{sumFee()}</b></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </Table>
                  <div className="clearfix"></div>
                </div>
                <div className="w-100 mb-2 text-white bg-green">
                  <h5 className="p-1">LỊCH SỬ GIAO HÀNG</h5>
                  <div className="clearfix"></div>
                </div>
                <div className="w-100 mb-2">
                  <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                    <thead className="thead-default">
                      <tr>
                        <th scope="col" className="text-center">#</th>
                        <th scope="col" className="text-left">Ngày giao</th>
                        <th scope="col" className="text-left">Người giao</th>
                        <th scope="col" className="text-right">Số tiền thu</th>
                        <th scope="col" className="text-center">Đã nhận tiền</th>
                        <th scope="col" className="text-left">Ghi chú</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listHistory && !!listHistory.length && (
                        listHistory.map((res, idx) => (
                          <tr key={idx + 1}>
                            <td className="text-center">{idx + 1}</td>
                            <td className="text-left">{res.NgayGiao && <Moment format="HH:mm DD/MM/YYYY">{`${res.NgayGiao}`}</Moment>}</td>
                            <td className="text-left">{res.TenNguoiGiao}</td>
                            <td className="text-right font-weight-bold">{(res.SoTienThu || 0).toLocaleString()}</td>
                            <td className="text-center">{res.DaNhanTien == 0 ? <span className="text-danger">Chưa nhận</span> : <span className="text-success">Đã nhận</span>}</td>
                            <td className="text-left">{res.GhiChu}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <div className="clearfix"></div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-sm-4 col-md-3 pull-left pl-0 pr-0">
            <Card>
              <CardBody className="p-2">
                <div className="w-100 mb-2">
                  <Form>
                    <FormGroup>
                      <div><Label>Ngày giao</Label></div>
                      <DatePicker
                        name="NgayGiao"
                        placeholder="Ngày giao"
                        selected={this.state.NgayGiao}
                        onChange={this.handleDateChange.bind(this, "NgayGiao")}
                        required className={"form-control"}
                        dateFormat="DD/MM/YYYY" />
                    </FormGroup>
                    <FormGroup>
                      <Label>Trạng thái</Label>
                      <select className="form-control" onChange={this.handleSelectChange.bind(this, "TrangThai")} value={this.state.TrangThai}>
                        <option value={0}>--Trạng thái--</option>
                        <option value={TrangThaiGiao.DangGiao.value}>{TrangThaiGiao.DangGiao.text}</option>
                        <option value={TrangThaiGiao.DaGiao.value}>{TrangThaiGiao.DaGiao.text}</option>
                        <option value={TrangThaiGiao.TamDung.value}>{TrangThaiGiao.TamDung.text}</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <Label>Số tiền thu</Label>
                      <NumberFormat
                        name={"ThanhToan"}
                        value={this.state.ThanhToan}
                        defaultValue={0}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        type="tel"
                        onClick={this.numberOnclick.bind(this)}
                        onValueChange={this.handleThanhToanChange.bind(this)}
                        className={"form-control order-input-price price"} />
                    </FormGroup>
                    <FormGroup>
                      <Label>Ghi chú</Label>
                      <textarea className="form-control" onChange={this.handleControlChange.bind(this)}></textarea>
                    </FormGroup>
                  </Form>
                </div>
                <div className="w-100 mb-2">
                  <Button size="md" color="success" className="mr-1" onClick={this.BackToListgiaoHang.bind(this, {})}><i className="fa fa-list"></i> Danh sách</Button>
                  <Button size="md" color="primary" className="mr-1" onClick={handleSubmit(this.UpdategiaoHang)}><i className="fa fa-retweet"></i> Cập nhật</Button>
                  <div className="error invalid-feedback">{formError.errMsg}</div>
                </div>
                <div>
                  {!isRequesting && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!isRequesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </div>
              </CardBody>
            </Card>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  giaoHangEdit: state.giaoHangEdit,
})
const connected = connect(mapStateToProps, {
  giaoHangDetailRequest: giaoHangAction.giaoHangDetailRequest,
  giaoHangUpdateRequest: giaoHangAction.giaoHangUpdateRequest,
  giaoHangListRequest: giaoHangAction.giaoHangListRequest,
  giaoHangHistoryListRequest: giaoHangAction.giaoHangHistoryListRequest
})(GiaoHangEdit)

const formed = reduxForm({
  form: 'giaoHangEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/GiaoHang/GiaoHangEdit.js